import { css } from 'linaria';

export const addressLine = css`
  display: inline !important;
  margin-right: var(--space-75);
`;

export const addressBlock = css`
  cursor: pointer;

  &:hover {
    svg {
      --i-color: var(--brand-dark) !important;
    }
  }
`;

export const copyIconStyle = css`
  vertical-align: bottom;
`;
